import api from './http';

export interface Region {
  id: number;
  name: string;
  code: string;
  display_order: number;
}

export interface District {
  id: number;
  region_id: number;
  name: string;
  code: string;
  display_order: number;
}

export interface Retailer {
  id: number;
  name: string;
  contact_person?: string;
  phone?: string;
  email?: string;
  status: string;
}

export interface Store {
  id: number;
  retailer_id: number;
  building_id: number;
  store_code: string;
  floor?: string;
  unit?: string;
  address_notes?: string;
  full_address?: string;
  status: string;
  retailer?: Retailer;
}

export const fetchRegions = async (): Promise<Region[]> => {
  const { data } = await api.get<Region[]>('/regions');
  return data;
};

export const fetchDistrictsByRegion = async (regionId: number): Promise<District[]> => {
  const { data } = await api.get<District[]>(`/districts/by-region/${regionId}`);
  return data;
};

export const fetchAllDistricts = async (): Promise<District[]> => {
  const { data } = await api.get<District[]>('/districts');
  return data;
};

export const fetchRetailersByDistrict = async (districtId: number): Promise<Retailer[]> => {
  const { data } = await api.get<Retailer[]>(`/retailers/by-district/${districtId}`);
  return data;
};

export const fetchStoresByRetailer = async (retailerId: number): Promise<Store[]> => {
  const { data } = await api.get<Store[]>(`/stores/by-retailer/${retailerId}`);
  return data;
};

